"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
const useStyles = function (props) {
  let isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let isItemOver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const {
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    view = 'default'
  } = props;
  const {
    pxToRem,
    setEndDirection
  } = (0, _useStylesUtils.useStylesUtils)();
  const ccItemStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          width: '100%'
        };
      }
      return {
        width: pxToRem(220),
        minHeight: pxToRem(258),
        height: '100%'
      };
    };
    const preloaderViewProps = () => {
      if (view === 'horizontal') {
        return {
          width: pxToRem(126)
        };
      }
      return {};
    };
    const containerViewProps = () => {
      if (view === 'horizontal') {
        return {
          display: 'grid',
          gridTemplateColumns: `${pxToRem(126)} 1fr`,
          gridTemplateRows: 'auto auto',
          borderRadius: pxToRem(6),
          overflow: 'hidden',
          background: themeColors?.general.light
        };
      }
      return {
        display: 'flex',
        flexDirection: 'column'
      };
    };
    const bannerViewProps = () => {
      if (view === 'horizontal') {
        return {
          width: pxToRem(126),
          borderRadius: pxToRem(0)
        };
      }
      return {
        width: pxToRem(220),
        height: pxToRem(186),
        borderRadius: pxToRem(5),
        textAlign: 'center'
      };
    };
    const bannerContentDeviceProps = () => {
      if (isMobileView) {
        return {
          opacity: 1
        };
      }
      return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: pxToRem(5),
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: 'transparent linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.41) 100%) 0% 0% no-repeat padding-box',
        opacity: isItemOver ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out'
      };
    };
    const contentViewProps = () => {
      if (view === 'horizontal') {
        return {
          minHeight: pxToRem(115),
          boxSizing: 'border-box',
          padding: `${pxToRem(13)} ${pxToRem(14)} ${pxToRem(9)}`,
          display: 'block',
          position: 'relative'
        };
      }
      return {
        flexGrow: 1,
        padding: `${pxToRem(9)} ${pxToRem(3)} ${pxToRem(3)}`,
        display: 'flex',
        flexDirection: 'column'
      };
    };
    const titleViewProps = () => {
      if (view === 'horizontal') {
        return {
          fontSize: pxToRem(16),
          lineHeight: pxToRem(18)
        };
      }
      return {
        fontSize: pxToRem(15),
        lineHeight: pxToRem(17)
      };
    };
    const infoViewProps = () => {
      if (view === 'horizontal') {
        return {
          position: 'absolute',
          left: pxToRem(14),
          right: pxToRem(14),
          bottom: pxToRem(9),
          fontSize: pxToRem(14),
          lineHight: pxToRem(16)
        };
      }
      return {
        width: '100%',
        fontSize: pxToRem(13),
        lineHeight: pxToRem(16),
        marginBottom: pxToRem(9)
      };
    };
    const extraContentViewProps = () => {
      if (view === 'horizontal') {
        return {
          gridColumnStart: 1,
          gridColumnEnd: 3,
          cursor: 'pointer'
        };
      }
      return {};
    };
    const ccItem = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      borderRadius: `${pxToRem(5)} ${pxToRem(5)} 0 0`,
      opacity: 1,
      maxHeight: pxToRem(305),
      transition: 'opacity 0.5s ease, height 0.5s ease-in-out, width 0.5s ease-in-out, transform 0.5s ease-in-out',
      userSelect: 'none',
      boxSizing: 'content-box',
      ...viewProps()
    });
    const ccItemPreloader = (0, _css.css)({
      backgroundColor: themeColors?.general.light,
      borderRadius: `${pxToRem(5)} ${pxToRem(5)} 0 0`,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1,
      ...preloaderViewProps()
    });
    const ccItemTags = (0, _css.css)({
      direction: direction,
      position: 'absolute',
      top: pxToRem(-7),
      display: 'flex',
      minWidth: '50%',
      justifyContent: 'flex-end',
      margin: `0 ${pxToRem(3)}`,
      ...setEndDirection(16),
      '& > div': {
        marginInlineStart: pxToRem(13),
        boxShadow: `0 ${pxToRem(1)} ${pxToRem(2)} #00000029`
      }
    });
    const ccItemContainer = (0, _css.css)({
      height: '100%',
      visibility: isReady ? 'visible' : 'hidden'
    });
    const ccItemMainContent = (0, _css.css)({
      position: 'relative',
      width: '100%',
      height: '100%',
      color: themeColors?.general.text,
      ...containerViewProps()
    });
    const ccItemBanner = (0, _css.css)({
      position: 'relative',
      backgroundColor: '#e8e8f6',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...bannerViewProps()
    });
    const ccItemBannerContent = (0, _css.css)({
      ...bannerContentDeviceProps()
    });
    const ccItemContent = (0, _css.css)({
      ...contentViewProps()
    });
    const ccItemTitle = (0, _css.css)({
      maxHeight: pxToRem(34),
      fontWeight: 'bold',
      marginBottom: pxToRem(1),
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...titleViewProps()
    });
    const ccItemInfo = (0, _css.css)({
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      transition: 'none',
      flexGrow: 1,
      color: themeColors?.general.subText,
      ...infoViewProps()
    });
    const ccItemSubTitle = (0, _css.css)({
      marginInlineEnd: pxToRem(20),
      color: themeColors?.general.subText
    });
    const ccItemDuration = (0, _css.css)({});
    const ccItemExtraContent = (0, _css.css)({
      position: 'relative',
      width: '100%',
      ...extraContentViewProps()
    });
    const ccItemExtraInfo = (0, _css.css)({
      position: 'relative',
      '&:empty': {
        display: 'none'
      }
    });
    return {
      ccItem,
      ccItemPreloader,
      ccItemTags,
      ccItemContainer,
      ccItemMainContent,
      ccItemBanner,
      ccItemBannerContent,
      ccItemContent,
      ccItemTitle,
      ccItemInfo,
      ccItemSubTitle,
      ccItemDuration,
      ccItemExtraContent,
      ccItemExtraInfo
    };
  }, [direction, isItemOver, isMobileView, isReady, pxToRem, setEndDirection, themeColors?.general.light, themeColors?.general.subText, themeColors?.general.text, view]);
  return {
    'cc-Item': ccItemStyle.ccItem,
    'cc-Item__preloader': ccItemStyle.ccItemPreloader,
    'cc-Item__tags': ccItemStyle.ccItemTags,
    'cc-Item__container': ccItemStyle.ccItemContainer,
    'cc-Item__main-content': ccItemStyle.ccItemMainContent,
    'cc-Item__banner': ccItemStyle.ccItemBanner,
    'cc-Item__banner-content': ccItemStyle.ccItemBannerContent,
    'cc-Item__content': ccItemStyle.ccItemContent,
    'cc-Item__title': ccItemStyle.ccItemTitle,
    'cc-Item__info': ccItemStyle.ccItemInfo,
    'cc-Item__sub-title': ccItemStyle.ccItemSubTitle,
    'cc-Item__duration': ccItemStyle.ccItemDuration,
    'cc-Item__extra-content': ccItemStyle.ccItemExtraContent,
    'cc-Item__extra-info': ccItemStyle.ccItemExtraInfo
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;